/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "{C320E6C5-0289-4152-B52D-34BE2E189034}",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://mc-22d65c2d-9cd3-404b-a7f4-0c1e-cd.azurewebsites.net",
config.sitecoreSiteName = process.env.REACT_APP_SITECORE_SITE_NAME || "bushs-beans",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://mc-22d65c2d-9cd3-404b-a7f4-0c1e-cd.azurewebsites.net/sitecore/api/graph/edge",
config.layoutServiceConfigurationName = process.env.REACT_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "default",
config.jssAppName = process.env.REACT_APP_JSS_APP_NAME || "bushs-beans",
module.exports = config;